import { render } from "./loginUser.vue?vue&type=template&id=68b84848&scoped=true"
import script from "./loginUser.vue?vue&type=script&lang=js"
export * from "./loginUser.vue?vue&type=script&lang=js"

import "./loginUser.vue?vue&type=style&index=0&id=68b84848&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b84848"]])

export default __exports__